import { TwoFactorSetupForm } from '@/components/forms/TwoFactorSetupForm'

export default function TwoFactorSetupPage() {
  return <TwoFactorSetupForm />
}

